import React from 'react';
import {withRouter} from 'react-router-dom';

export const ScrollToTop = withRouter(({history, children}) => {

    React.useEffect(() => {
        const scrollToTop = history.listen(() => window.scrollTo(0, 0));
        return () => {
            scrollToTop();
        };
    }, [history]);

    return <>{children}</>;
});
